class BrewSteps extends HTMLElement {
  constructor() {
    super();
    this.sliderMobile = this.querySelector(".brew-steps__track");
    this.slider = this.querySelector(".brew-steps__track-wrapper");
    this.sliderItems = this.querySelectorAll(".brew-steps__media-entry");
    this.copySteps = this.querySelectorAll(".brew-steps__copy-step");
    this.prevButton = this.querySelector(".brew-steps__prev");
    this.nextButton = this.querySelector(".brew-steps__next");



    if (!this.slider || !this.sliderItems) {
      console.error("Brew Steps Slider: Slider or Slider Items not found");
      return;
    }

    if (!this.prevButton || !this.nextButton) {
      console.log("Brew Steps Slider: Previous or Next button not found");
    }

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.sliderMobile.addEventListener("scroll", this.updateMobile.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.copySteps.forEach((step, index) => {
      step.addEventListener("click", (e) => this.onStepClick(e, index));
    });

    this.snapToNearestSlide = this.snapToNearestSlide.bind(this);
  }


  connectedCallback() {
    const track = this.querySelector(".brew-steps__track");
    const trackWrapper = this.querySelector(".brew-steps__track-wrapper");

    // Setup slides
    const firstSlide = track.querySelector('.brew-steps__media-entry');
    const slideWidth = firstSlide ? firstSlide.offsetWidth : 0;
    const gap = parseFloat(getComputedStyle(trackWrapper).getPropertyValue('gap')) || 0;
    const slideWidthWithGap = slideWidth + gap;
    const centerOffset = ((slideWidth / 2) - (track.offsetWidth / 2)) + ((track.offsetWidth - trackWrapper.offsetWidth) / 2);
    this.snapToNearestSlide = this.snapToNearestSlide.bind(this, slideWidthWithGap, centerOffset);
    const slideCount = track.querySelectorAll('.brew-steps__media-entry').length;

    // Event handling
    let isDown = false;
    let ticking = false;
    let startX;
    let scrollLeft;

    track.addEventListener("mousedown", (e) => {
      isDown = true;
      track.classList.add("active");
      startX = e.pageX - track.getBoundingClientRect().left;
      scrollLeft = track.scrollLeft;
    });

    track.addEventListener("mouseleave", () => {
      isDown = false;
      track.classList.remove("active");
    });

    track.addEventListener("mouseup", () => {
      isDown = false;
      setTimeout(() => {
        this.snapToNearestSlide(track.scrollLeft);
        setTimeout(() => {
          track.classList.remove("active");
        }, 750);
      }, 200);
    });

    track.addEventListener("mousemove", (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.getBoundingClientRect().left;
      const walk = (x - startX) * 2;
      track.scrollLeft = scrollLeft - walk;
    });


  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / sliderItemsToShow[0].clientWidth
    );
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.copySteps || !this.totalPages) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1 && this.prevButton) {
      this.prevButton.setAttribute("disabled", true);
    } else if (this.prevButton) {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages && this.nextButton) {
      this.nextButton.setAttribute("disabled", true);
    } else if (this.nextButton) {
      this.nextButton.removeAttribute("disabled");
    }

    this.copySteps.forEach((step) => {
      if (step.id === `brew-step--${this.currentPage}`) {
        step.classList.add("is-active");
      } else {
        step.classList.remove("is-active");
      }
    });

    this.sliderItems.forEach((slide) => {
      if (slide.querySelector("video") === null) return;
      const video = slide.querySelector("video");
      if (slide.id === `brew-step-media--${this.currentPage}`) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  updateMobile() {
    if (!this.copySteps || !this.totalPages) return;
    this.currentPage =
      Math.round(this.sliderMobile.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1 && this.prevButton) {
      this.prevButton.setAttribute("disabled", true);
    } else if (this.prevButton) {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages && this.nextButton) {
      this.nextButton.setAttribute("disabled", true);
    } else if (this.nextButton) {
      this.nextButton.removeAttribute("disabled");
    }

    this.copySteps.forEach((step) => {
      if (step.id === `brew-step--${this.currentPage}`) {
        step.classList.add("is-active");
      } else {
        step.classList.remove("is-active");
      }
    });

    this.sliderItems.forEach((slide) => {
      if (slide.querySelector("video") === null) return;
      const video = slide.querySelector("video");
      if (slide.id === `brew-step-media--${this.currentPage}`) {
        video.play();
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }

  onButtonClick(e) {
    e.preventDefault();
    const slideScrollPosition =
      e.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderLastItem.clientWidth
        : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: "smooth",
    });
  }

  onStepClick(e, index) {
    e.preventDefault();
    const slideScrollPosition = this.sliderLastItem.clientWidth * index;
    this.slider.scrollTo({
      left: slideScrollPosition,
      behavior: "smooth",
    });
  }

  snapToNearestSlide(slideWidthWithGap, centerOffset, currentScroll) {
    const index = Math.round(currentScroll / (slideWidthWithGap + centerOffset));
    const targetScrollPosition = (index * slideWidthWithGap) + centerOffset;
    this.querySelector(".brew-steps__track-wrapper").scrollTo({
      left: targetScrollPosition,
      behavior: "smooth"
    });
  }

  disconnectedCallback() {
    if (this.productPilotsSlider) {
      this.productPilotsSlider.destroy();
    }
  }

}

if (!customElements.get('brew-steps')) {
  customElements.define('brew-steps', BrewSteps);
}
